// src/components/calendar/AddEventModal.jsx
import React from 'react';
import { Drawer, DialogContent, DialogTitle, DialogActions, Button } from '@mui/material';
import TrainingForm from '../training/TrainingForm'; // Asegúrate de que la ruta es correcta

const AddEventModal = ({
    open,
    onClose,
    onAddTraining,
    onEditTraining,
    trainingToEdit,
    setTrainingToEdit,
    handleCancelEdit
}) => {
    return (
        <Drawer
            anchor="right" // Esto hace que el Drawer se abra desde la derecha
            open={open}
            onClose={onClose}
            sx={{
                width: '900px', // Puedes ajustar el ancho del Drawer
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: '900px', // Asegúrate de que el ancho del papel sea el mismo
                    boxSizing: 'border-box',
                },
            }}
        >
            <DialogContent>
                <TrainingForm
                    onAddTraining={onAddTraining}
                    onEditTraining={onEditTraining}
                    trainingToEdit={trainingToEdit}
                    setTrainingToEdit={setTrainingToEdit}
                    handleCancelEdit={handleCancelEdit}
                />
            </DialogContent>
        </Drawer>
    );
};

export default AddEventModal;